<template>
  <section>
    <salary-intro></salary-intro>
    <input-bar></input-bar>
    <player-details></player-details>
    <player-footer></player-footer>
  </section>
</template>

<style lang="scss" scoped>
  
</style>

<script>
import SalaryIntro from "@/components/PlayerSalary/SalaryIntro";
import InputBar from "@/components/PlayerSalary/InputBar";
import PlayerDetails from "@/components/PlayerSalary/PlayerDetails";
import PlayerFooter from "@/components/Shared/TeamFooter";

export default {
  components: {
    SalaryIntro,
    InputBar,
    PlayerDetails,
    PlayerFooter,
  },
};
</script>